import React from 'react'
import '../styles.scss'

import FileItem from './file-item'

export default ({files, on_remove, on_error_fix}) => (
  <div className='files'>
    {files.map((file, i) => {return <FileItem key={i} file={file} on_remove={on_remove} on_error_fix={on_error_fix}/>})}
  </div>
)
